<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="撤销申请"
        width="400px"
        top="10vh">
      <span>是否同意撤销？</span>
      <span slot="footer">
        <el-button type="danger" @click="checkRepeal(20)">拒绝撤销</el-button>
        <el-button type="primary" @click="checkRepeal(30)">确定撤销</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


  export default {
    name:"CheckRepeal",
    components: {},
    data() {
      return {
        dialogVisible: false,
        ruleValidate: {},
        pkid:0,
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.pkid = id;
      },
      checkRepeal(type) {
        this.$http
          .get("basic",`repairOrders/repealStatus/${this.pkid}/type/${type}`).then(() => {
            this.$emit("save-success");
            this.dialogVisible = false;
            this.$message.success("操作成功");
          }).catch(() => {
            this.dialogVisible = false;
            this.$message.error("操作失败");
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
